import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class HideViewsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('hideViews', { ids: ids });
  }
}
